import script from "./PoorQuality.vue?vue&type=script&setup=true&lang=ts"
export * from "./PoorQuality.vue?vue&type=script&setup=true&lang=ts"

import "./PoorQuality.vue?vue&type=style&index=0&id=caee8fa0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-caee8fa0"]])

export default __exports__